

















import Vue from 'vue';

export default Vue.extend({
  name: 'UserMenu',
  props: {
    menu: Object as () => {x?: number, y?: number}
  },
  computed: {
    showMenu(): boolean {
      return !!this.menu.x;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('logOut');
    },
    onClose() {
      this.menu.x = 0;
    }
  }
});
